export default "__VITE_ASSET__DQ2wdEid__"